import { APICall } from "@/config/NetworkUtility";
import { getErrorPayload } from "@/utils/reduxError";

const SUCCESS_CODES = [200, 201];

export const customBaseQuery = async ({
    url,
    method = "GET",
    body = null,
    params = {},
}) => {
    try {
        const result = await APICall(
            method,
            body,
            buildUrl(url, params)
        );

        const statusCode =
            result?.statuscode ??
            result?.statusCode;

        // ==========================================
        // SUCCESS RESPONSE
        // Return the complete API response
        // ==========================================
        if (SUCCESS_CODES.includes(statusCode)) {
            return {
                data: result,
            };
        }

        // ==========================================
        // API ERROR RESPONSE
        // ==========================================
        return {
            error: {
                status: statusCode,
                data: {
                    message:
                        result?.message ||
                        "Something went wrong.",

                    data:
                        result?.data ??
                        null,
                },
            },
        };
    } catch (error) {
        // ==========================================
        // NETWORK / AXIOS / UNKNOWN ERROR
        // ==========================================
        return {
            error: getErrorPayload(error),
        };
    }
};

// ==========================================
// BUILD QUERY STRING
// ==========================================

function buildUrl(url, params = {}) {
    const query = new URLSearchParams(
        Object.entries(params).filter(
            ([, value]) =>
                value !== undefined &&
                value !== null &&
                value !== ""
        )
    ).toString();

    if (!query) {
        return url;
    }

    return `${url}${url.includes("?") ? "&" : "?"
        }${query}`;
}